import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../admin/app';
import FieldSet from '../../common/components/FieldSet';
import Button from '../../common/components/Button';
import Alert from '../../common/components/Alert';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import AdminPage from './AdminPage';
import Form from '../../common/components/Form';
import ItemList from '../../common/utils/ItemList';
export default class MailPage extends AdminPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "sendingTest", false);
    _defineProperty(this, "status", void 0);
    _defineProperty(this, "driverFields", void 0);
    _defineProperty(this, "testEmailSuccessAlert", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.refresh();
  }
  headerInfo() {
    return {
      className: 'MailPage',
      icon: 'fas fa-envelope',
      title: app.translator.trans('core.admin.email.title'),
      description: app.translator.trans('core.admin.email.description')
    };
  }
  refresh() {
    this.loading = true;
    this.status = {
      sending: false,
      errors: {}
    };
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/mail/settings'
    }).then(response => {
      this.driverFields = response.data.attributes.fields;
      this.status.sending = response.data.attributes.sending;
      this.status.errors = response.data.attributes.errors;
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m(LoadingIndicator, null);
    }
    const mailSettings = this.mailSettingItems().toArray();
    return m('[', null, m(Form, null, mailSettings.map(settingComponent => settingComponent), m("div", {
      className: "Form-group Form-controls"
    }, this.submitButton())), m(Form, null, m(FieldSet, {
      label: app.translator.trans('core.admin.email.send_test_mail_heading'),
      className: "FieldSet--col MailPage-MailSettings",
      description: app.translator.trans('core.admin.email.send_test_mail_text', {
        email: app.session.user.email()
      })
    }, m(Button, {
      className: "Button Button--primary",
      disabled: this.sendingTest || this.isChanged(),
      onclick: () => this.sendTestEmail()
    }, app.translator.trans('core.admin.email.send_test_mail_button')))));
  }
  mailSettingItems() {
    const items = new ItemList();
    const fields = this.driverFields[this.setting('mail_driver')()] || {};
    const fieldKeys = Object.keys(fields);
    if (!this.status.sending) {
      items.add('status', m(Alert, {
        dismissible: false
      }, app.translator.trans('core.admin.email.not_sending_message')));
    }
    items.add('mail_from', this.buildSettingComponent({
      type: 'text',
      setting: 'mail_from',
      label: app.translator.trans('core.admin.email.addresses_heading')
    }), 80);
    items.add('mail_format', this.buildSettingComponent({
      type: 'select',
      setting: 'mail_format',
      options: {
        multipart: app.translator.trans('core.admin.email.format.multipart_option'),
        plain: app.translator.trans('core.admin.email.format.plain_option'),
        html: app.translator.trans('core.admin.email.format.html_option')
      },
      label: app.translator.trans('core.admin.email.format_heading'),
      help: app.translator.trans('core.admin.email.format_help')
    }), 70);
    items.add('mail_driver', this.buildSettingComponent({
      type: 'select',
      setting: 'mail_driver',
      options: Object.keys(this.driverFields).reduce((memo, val) => _objectSpread(_objectSpread({}, memo), {}, {
        [val]: val
      }), {}),
      label: app.translator.trans('core.admin.email.driver_heading')
    }), 60);
    if (!!fieldKeys.length) {
      const driver = this.setting('mail_driver')();
      const descriptionKey = "core.admin.email.".concat(driver, "_description");
      const descriptionText = app.translator.trans(descriptionKey);
      items.add('mail_driver_settings', m(FieldSet, {
        label: app.translator.trans("core.admin.email.".concat(driver, "_heading")),
        className: "MailPage-MailSettings FieldSet--form",
        description: descriptionText
      }, fieldKeys.map(field => {
        const fieldInfo = fields[field];

        // For encryption field, show all help text options above the dropdown
        let helpText;
        if (field === 'mail_encryption') {
          const tlsHelp = app.translator.trans('core.admin.email.mail_encryption_tls_help');
          const sslHelp = app.translator.trans('core.admin.email.mail_encryption_ssl_help');
          const noneHelp = app.translator.trans('core.admin.email.mail_encryption_none_help');
          helpText = m('[', null, m("div", null, m("strong", null, "TLS:"), " ", tlsHelp), m("div", null, m("strong", null, "SSL:"), " ", sslHelp), m("div", null, m("strong", null, "None:"), " ", noneHelp));
        } else {
          const helpKey = "core.admin.email.".concat(field, "_help");
          const translatedHelp = app.translator.trans(helpKey);
          helpText = translatedHelp !== helpKey ? translatedHelp : undefined;
        }
        return m('[', null, this.buildSettingComponent({
          type: typeof fieldInfo === 'string' ? 'text' : typeof fieldInfo === 'boolean' ? 'bool' : 'select',
          label: app.translator.trans("core.admin.email.".concat(field, "_label")),
          setting: field,
          options: fieldInfo,
          help: helpText
        }), this.status.errors[field] && m("div", {
          className: "ValidationError"
        }, Array.isArray(this.status.errors[field]) ? this.status.errors[field].map(error => m("p", {
          key: error
        }, error)) : m("p", null, this.status.errors[field])));
      })), 50);
    }
    return items;
  }
  sendTestEmail() {
    if (this.sendingTest) return;
    this.sendingTest = true;
    if (this.testEmailSuccessAlert) app.alerts.dismiss(this.testEmailSuccessAlert);
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/mail/test'
    }).then(response => {
      this.sendingTest = false;
      this.testEmailSuccessAlert = app.alerts.show({
        type: 'success'
      }, app.translator.trans('core.admin.email.send_test_mail_success'));
    }).catch(error => {
      this.sendingTest = false;
      m.redraw();
      throw error;
    });
  }
  saveSettings(e) {
    return super.saveSettings(e).then(() => this.refresh());
  }
  static register() {
    app.generalIndex.group('core-mail', {
      label: app.translator.trans('core.admin.email.title', {}, true),
      icon: {
        name: 'fas fa-envelope'
      },
      link: app.route('mail')
    });
    app.generalIndex.for('core-mail').add('settings', [{
      id: 'mail_from',
      label: app.translator.trans('core.admin.email.addresses_heading', {}, true)
    }, {
      id: 'mail_format',
      label: app.translator.trans('core.admin.email.format_heading', {}, true),
      help: app.translator.trans('core.admin.email.format_help', {}, true)
    }, {
      id: 'mail_driver',
      label: app.translator.trans('core.admin.email.driver_heading', {}, true)
    }, {
      id: 'send_test_mail_heading',
      label: app.translator.trans('core.admin.email.send_test_mail_heading', {}, true),
      help: app.translator.trans('core.admin.email.send_test_mail_text', {
        email: app.session.user.email()
      }, true)
    }]);
  }
}
flarum.reg.add('core', 'admin/components/MailPage', MailPage);